import React, { useEffect, useState } from "react";
import { Box, Text, Button, Flex, Image, Center, Spinner, Tag, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, IconButton, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, useToast, HStack, Grid, ModalFooter } from "@chakra-ui/react";
import axiosClient from "../../../axios-client";
import { useLocation, useNavigate } from "react-router-dom";
import { DeleteIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";
import { FiFilter } from "react-icons/fi";
import { GiSettingsKnobs } from "react-icons/gi";
import { VscSettings } from "react-icons/vsc";
import PlayVideo from "../PlayVideo";
import { BsClockHistory } from "react-icons/bs";
import { Tooltip } from "chart.js";
import { ImStatsBars } from "react-icons/im";

const MovieDetails = () => {
    const [movieDetails, setMovieDetails] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [mediaToShow, setMediaToShow] = useState(null);
    const [typeMedia, setTypeMedia] = useState('');
    const [mediaName, setMediaName] = useState('');
    const location = useLocation()
    const navigate = useNavigate()
    const cancelRef = React.useRef()
    const { t } = useTranslation()
    const toast = useToast()
    const [filterChunks, setFilterChunks] = useState([]);
    const [isMovieFiltersOpen, setIsMovieFiltersOpen] = useState(false);

    useEffect(() => {
        // Fetch movie details from API
        axiosClient
            .get(`/movies/${location.state.movieId}/`)
            .then((response) => {
                setMovieDetails(response.data);
                setFilterChunks(response.data.filter_chunks || [])
            })
            .catch((error) => {
                // console.error("Error fetching movie details:", error);
            });
    }, [location.state.movieId]);

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const onOpenAlert = () => {
        setIsAlertOpen(true);
    };

    const onCloseAlert = () => {
        setIsAlertOpen(false);
    };
    const onOpenMovieFilters = () => {
        setIsMovieFiltersOpen(true);
    };

    const onCloseMovieFilters = () => {
        setIsMovieFiltersOpen(false);
    };
    const openModal = (mediaUrl, mediaName) => {
        setMediaToShow(mediaUrl);
        setMediaName(mediaName)
        setTypeMedia((mediaName === "Bande-annonce" || mediaName === "Vidéo" || mediaName === "Extrait") ? "video" : "image")
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setMediaToShow(null);
    };

    if (!movieDetails) {
        return (
            <Center h="50vh" mt={10}>
                <Spinner size="xl" />
            </Center>
        );
    }

    const mediaButtons = [
        { name: 'Image paysage', url: movieDetails?.image_Hquality || movieDetails?.image },
        { name: 'Image portrait', url: movieDetails?.poster_Hquality || movieDetails?.poster },
        { name: 'Logo', url: movieDetails?.logo },
        { name: 'Bande-annonce', url: movieDetails?.trailerUrl },
        { name: 'Vidéo', url: movieDetails?.videoUrl },
        { name: 'Extrait', url: movieDetails?.excerptUrl },
    ];

    const handleDelete = (id) => {
        if (!id) return;
        axiosClient.delete(`/movies/delete/${id}/`)
            .then((response) => {
                toast({
                    description: t("Le film est supprimé avec succès"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                })
                navigate('/films')
            })
            .catch((error) => {
            });
        onCloseAlert()
    }
    const formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${hours > 0 ? `${hours}h ` : ""}${minutes > 0 ? `${minutes}m ` : ""}${secs.toFixed(3)}s`;
    };

    return (
        <Box p={5} mt="10px" display="flex" flexDirection={"column"}>
            <Box w={"100%"} mt={3} mb={2}>
                <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t('Accueil')}</span>  / <span onClick={() => navigate('/films')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t('Liste des films')}</span> / <span> {t('Détails du film')}</span></Text>
            </Box>
            <Box minH="25rem" display="flex" flexDirection={{ base: "column", md: "row" }} justifyContent="center" alignItems="center" gap={8}>
                <Box display="flex" flexDirection="column" justifyContent="center" w={{ base: "100%", md: "50%" }} h="full" textAlign="left">
                    <Text fontSize="5xl" fontWeight="bold" mb={2}>
                        {movieDetails?.title}
                    </Text>
                    <Text color="gray.500" fontSize="lg" mb={5}>
                        {movieDetails?.description}
                    </Text>

                    {/* Render Subcategories as Tags */}
                    <Flex wrap="wrap" gap={2}>
                        {movieDetails?.subcategory_names?.map((subCategory, index) => (
                            <Tag key={index} colorScheme="orange">{subCategory}</Tag>
                        ))}
                    </Flex>

                    <Box w="full" h="0.1rem" my={5} bg="gray.300" />

                    <Flex justifyContent="space-between" alignItems="center" w="full">
                        <Box w={"100%"}>
                            <Text color="orange.400">
                                Sorti le:{" "}
                                <Text as="span" color="gray.500" ml={1}>
                                    {movieDetails?.releaseDate}
                                </Text>
                            </Text>
                            <Text color="orange.400">
                                Langue:{" "}
                                <Text as="span" color="gray.500" ml={1}>
                                    {movieDetails?.language}
                                </Text>
                            </Text>
                            <Text color="orange.400">
                                Durée:{" "}
                                <Text as="span" color="gray.500" ml={1}>
                                    {movieDetails.duration < 60
                                        ? `${movieDetails.duration} secs`
                                        : movieDetails.duration < 3600
                                            ? `${Math.floor(movieDetails.duration / 60)} min${Math.floor(movieDetails.duration / 60) > 1 ? "s" : ""} ${movieDetails.duration % 60 > 0 ? `${movieDetails.duration % 60} secs` : ""
                                            }`
                                            : `${Math.floor(movieDetails.duration / 3600)} hr${Math.floor(movieDetails.duration / 3600) > 1 ? "s" : ""} ${Math.floor((movieDetails.duration % 3600) / 60) > 0
                                                ? `${Math.floor((movieDetails.duration % 3600) / 60)} min${Math.floor((movieDetails.duration % 3600) / 60) > 1 ? "s" : ""}`
                                                : ""
                                            } ${movieDetails.duration % 60 > 0 ? `${movieDetails.duration % 60} secs` : ""}`}

                                </Text>
                            </Text>
                            <Flex mt={1} wrap="wrap" gap={2}>
                                <Text color="orange.400">
                                    Disponible en :
                                </Text>
                                <Text color="gray.500">
                                    {movieDetails?.pays_names?.join(" - ") || "Tous les pays"}
                                </Text>
                            </Flex>

                        </Box>
                        <Flex gap={2}>
                            {/* <IconButton
                                size="md"
                                onClick={() => {
                                    onOpenAlert();
                                }}
                                mr="5px"
                                colorScheme="red"
                                icon={<DeleteIcon />}>
                            </IconButton> */}
                            <IconButton
                                onClick={() =>
                                    navigate(`/content-stats`, {
                                        state: {
                                            contentId: movieDetails?.id,
                                            breadcrumbs: [
                                            { path: '/films', label: 'Liste des films' },
                                            { path: -1, label: 'Détails du film' } 
                                        ]
                                        },
                                        
                                    })
                                }
                                size={"md"}
                                variant='outline'
                                colorScheme='blackAlpha'
                                aria-label='Statistiques'
                                icon={<ImStatsBars color='orange' size={18} />}
                            />


                            <Button
                                bg={"#fa8d51"}
                                color={"white"}
                                variant="solid"
                                size="md"
                                _hover={"none"}
                                onClick={() =>
                                    navigate(`/modifier-film`, {
                                        state: {
                                            movieId: movieDetails?.id,
                                        },
                                    })
                                }
                            >
                                Modifier
                            </Button>

                        </Flex>

                    </Flex>


                </Box>

                <Box w={{ base: "100%", md: "50%" }} display="flex" justifyContent="center" alignItems="center" mt={{ base: 5, md: 0 }}>
                    {(movieDetails?.image_Hquality || movieDetails?.image) && (
                        <Image
                            style={{ maxHeight: "350px" }}
                            boxSize="full"
                            objectFit="cover"
                            src={movieDetails?.image_Hquality || movieDetails?.image}
                            alt={movieDetails?.title}
                        />
                    )}
                </Box>


            </Box>
            {/* Media Buttons */}
            <Grid w="100%" templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(4, 1fr)", xl: "repeat(7, 1fr)" }} gap={4} mt={8}>
                {mediaButtons.map((button, index) => (
                    <Button
                        w={'full'}
                        key={index}
                        onClick={() => openModal(button.url, button.name)}
                        isDisabled={!button.url}
                        variant={"outline"}
                        colorScheme={button.url ? "blue" : "blue"}
                    >
                        {button.name}
                    </Button>
                ))}
                <Button
                    w={'full'}
                    onClick={() => {
                        onOpenMovieFilters();
                    }}
                    colorScheme={"green"}
                >

                    Filtres
                    <VscSettings size={"18px"} style={{ marginLeft: "5px" }} />
                </Button>
            </Grid>
            {/* Modal to Show Media */}
            <Modal bg={'transparent'} size={typeMedia === "video" ? "5xl" : "2xl"} isOpen={isModalOpen} onClose={closeModal}>
                <ModalOverlay bg={'blackAlpha.700'} backdropFilter='auto'
                />
                <ModalContent bg={'transparent'} shadow={"none"}>
                    {/* <ModalHeader>Media Display</ModalHeader> */}
                    {/* <ModalCloseButton /> */}
                    <ModalBody>

                        {typeMedia === "video" ? (
                            mediaName === "Vidéo" ? <PlayVideo id={movieDetails?.id} type={"movie"} /> :
                                <video controls src={mediaToShow} style={{ width: '100%', height: 'auto' }} />

                        ) : (
                            <Image src={mediaToShow} alt="Media" boxSize="full" objectFit="contain" />
                        )}


                    </ModalBody>
                </ModalContent>
            </Modal>
            <AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer le film")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={() => handleDelete(movieDetails?.id)} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
            <Modal bg={'transparent'} isOpen={isMovieFiltersOpen} onClose={onCloseMovieFilters}>
                <ModalOverlay
                />
                <ModalContent >
                    <ModalHeader>Filtres par section </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {filterChunks?.length > 0 ?
                            filterChunks.map((chunk, index) => (
                                <HStack w={"100%"} mr={5} color="gray.700" key={index} spacing={3} justify="start">
                                    <Text>{chunk.start ? "De " + formatTime(chunk.start) : "Début (sec)"}</Text>
                                    <Text>{chunk.end ? "à " + formatTime(chunk.end) : "Fin (sec)"}</Text>
                                    <Text>{" : " + chunk.label.toLowerCase() || "Étiquette"}</Text>
                                </HStack>
                            )) :
                            <Text color={'gray.500'}>Aucun filtre disponible</Text>}
                    </ModalBody>
                    <ModalFooter></ModalFooter>
                </ModalContent>
            </Modal>
        </Box>

    );
};

export default MovieDetails;
